export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">有任何问题或建议？欢迎通过以下方式与我们取得联系</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="text-center p-5 bg-background-50 rounded-xl">
              <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1">投稿合作</h3>
              <p className="text-xs text-foreground-500">contact@91yinghua.com</p>
            </div>
            <div className="text-center p-5 bg-background-50 rounded-xl">
              <div className="w-12 h-12 bg-accent-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-bug-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">support@91yinghua.com</p>
            </div>
            <div className="text-center p-5 bg-background-50 rounded-xl">
              <div className="w-12 h-12 bg-secondary-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-links-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1">友情链接</h3>
              <p className="text-xs text-foreground-500">link@91yinghua.com</p>
            </div>
          </div>

          <div className="text-center p-6 bg-background-50 rounded-xl border border-background-200/60">
            <p className="text-sm text-foreground-600 mb-3">如需获取最新网址或有紧急访问问题</p>
            <a
              href="#updates"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <i className="ri-arrow-up-line"></i>
              查看实时快讯获取最新入口
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}